import moment from 'moment';
import requestUtil from '../../helpers/requestUtil';
import { setLoading } from '../common/Loader/slice';
import { saveJobOpportunity } from './jobOpportunityUtils';
import { convertToString } from './recurrenceConvertToString/recurrenceConvertToString';
import { destructure } from './recurrenceDestructure/recurrenceDestructure';
import { structure } from './recurrenceStructure/recurrenceStructure';
import {
  addcovidVaccination,
  addLocationApprover,
  addLocationContactPerson,
  clearContactAndApprovalUser,
  loadDataForEdit,
  loadJobId,
  removecovidVaccination,
  removeLocationApprover,
  removeLocationContactPerson,
  resetJobOpportunity,
  setCalenderData,
  setDisplayContactApprovererror,
  setDistance,
  setDropdownJobId,
  setFailureLogs,
  setFormData,
  setJobEncounterOccurreneUpdateList,
  setjobMultishiftOccurreneUpdateList,
  setLoadingFlagDecrement,
  setLoadingFlagIncrement,
  setMasterData,
  setMatchingCandidateData,
  setMonth,
  setrepeatEvery,
  setResetDropdown,
  setreursionFlag,
  setrrule,
  setrruleStr,
  setSelectedOption,
  setWeeks,
  setYear,
  updateCertificationInfo,
  updateCovidInfo,
  updateEducationInfo,
  updateEducationLevelMasterData,
  updateEMREHRSystemExpInfo,
  updateErrors,
  updateJobCategoryMasterData,
  updateJobcertificationsMasterData,
  updateJobDescription,
  updateJobemrEhrSystemExpMasterData,
  updateJobInfo,
  updateJobSaveAPIErrors,
  updateJobspecialitiesMasterData,
  updateJobTypeDetails,
  updateLocationAddress,
  updateLocationContactsInMasterData,
  updateLocationDetails,
  updateMedicalSpecialityInfo,
  updateShiftDetails,
  updateStartJobDetails,
  updateTemplateInfo,
  setAuthUsers,
  setGrouping,
  updateCalendarLocationDetail,
  resetShiftAmount,
  setIncentiveMarkup,
  updateLocationList,
  setAutoRepost,
  setPayRateType
} from './slice';
import { updateJobDetails } from './Summary/slice';
import {
  formToSummary,
  patchDynamicForm,
  selectedTemplateToForm,
  summaryToForm,
  updateShiftTime,
} from './transformer';
import * as Toasts from '../common/Toastify';
import { getDateJsFormat } from '../../helpers/service';
import { shiftTypeObj } from '../../helpers/data';
import { updateSharedSlice } from '../shared/sharedSlice';

const login = JSON.parse(sessionStorage.getItem('login'));
export function setJobDescription() {
  return async (dispatch) => {
    const description = window.descriptionValue();
    dispatch(updateJobDescription(description));
    return description;
  };
}

export function updateJobType(url, field, value) {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const payload = { field: field, data: value };
      dispatch(updateJobTypeDetails(payload));
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    }
    dispatch(setLoading(false));
  };
}

export function updateStartJob(url, field, value) {
  //console.log(field, value, 'Test ram1')
  return async (dispatch, getState) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());
    try {
      if (field === 'templateID') {
        //console.log(field, value, 'Test ram2')
        const state = getState();
        const { masterData, formdata, jobInfo } = state.jobOpportunity;
        const {depsUnitsMaster} = state.login;
        const jobOpportunityData = await requestUtil(
          `${url}/Employers/get-job-template-info?id=${value?.id}`,
          'POST'
        );

        let updatedMasterDataNew = {};
        let dynamicFormData = []
        if (masterData?.allJobTypes.length > 1) {
          const educationLevelDetails = await requestUtil(
            `${url}/Dropdown/GetLevelOfEducationsV2/${jobOpportunityData?.jobTypeID}`,
            'GET'
          );
          const jobOpportunityDetails = await requestUtil(
            `${url}/Dropdown/getjobcategories/${jobOpportunityData?.jobTypeID}`,
            'GET'
          );
          // const emrEhrSystemExp = await requestUtil(
          //   `${url}/Dropdown/getemrehrsystems/${jobOpportunityData?.jobTypeID}`,
          //   'GET'
          // );
          // const certifications = await requestUtil(
          //   `${url}/Dropdown/getcertifications/${jobOpportunityData?.jobTypeID}`,
          //   'GET'
          // );
          // const specialities = await requestUtil(
          //   `${url}/Dropdown/getspecialties/${jobOpportunityData?.jobTypeID}`,
          //   'GET'
          // );
          const dynamicform = await requestUtil(
            `${url}/Employers/get-dynamic-QA-for-job-creation`,
            'POST',
            { jobLevel: [jobOpportunityData?.jobCategoryId] }
          );
          console.log('Fine-1');
          updatedMasterDataNew = {
            ...updatedMasterDataNew,
            ...masterData,
            allEducationLevels: [...educationLevelDetails],
            allJobCategory: [...jobOpportunityDetails],
            // allCertifications: [...certifications],
            // allMedicalSpecialities: [...specialities],
            // allEmrEhrSystemExperience: [...emrEhrSystemExp],
          };
          if (dynamicform?.tabsList) {
            dynamicFormData = dynamicform?.tabsList
          }
          dispatch(updateEducationLevelMasterData(educationLevelDetails));
          dispatch(updateJobCategoryMasterData(jobOpportunityDetails));
          // dispatch(updateJobcertificationsMasterData(certifications));
          // dispatch(updateJobspecialitiesMasterData(specialities));
          // dispatch(updateJobemrEhrSystemExpMasterData(emrEhrSystemExp));
          dispatch(updateDropDownJobId(jobOpportunityData?.jobTypeID));
          if (dynamicform?.tabsList) {
            dispatch(setFormData(dynamicform?.tabsList));
          }
        } else {
          updatedMasterDataNew = { ...masterData };
          dynamicFormData = formdata
        }
        const jobIdFlag = JSON.parse(sessionStorage.getItem("login"));
        if( jobOpportunityData?.jobCategoryId && !jobIdFlag?.accountFlags?.isShowQATab ){
                const params = {
                  jobLevel:[jobOpportunityData?.jobCategoryId]
                };
                const emrEhrSystemExp = await requestUtil(
                  `${url}/Dropdown/Get-New-EMREHRSystems-byJobLevel`,
                  'POST',{...params}
                );
                const certifications = await requestUtil(
                  `${url}/Dropdown/Get-New-Certifications-byJobLevel`,
                  'POST',{...params}
                );
                const specialities = await requestUtil(
                  `${url}/Dropdown/Get-New-Specialties-byJobLevel`,
                  'POST',{...params}
                );

                  updatedMasterDataNew = {...updatedMasterDataNew, 
                  allCertifications: [...certifications],
                  allMedicalSpecialities: [...specialities],
                  allEmrEhrSystemExperience: [...emrEhrSystemExp]}
                  dispatch(updateJobcertificationsMasterData(certifications));
                  dispatch(updateJobspecialitiesMasterData(specialities));
                  dispatch(updateJobemrEhrSystemExpMasterData(emrEhrSystemExp));
        }
        jobOpportunityData?.locationId &&
          dispatch(
            updateLocationDropdownsInMasterData(
              url,
              jobOpportunityData?.locationId
            )
          )
            .then((location) => {
              const updatedMasterData = {
                ...updatedMasterDataNew,
                allJobLocationContactPersons: location?.contactsForLocation,
                allJobLocationApprovers: location?.approversForLocation,
                depsUnitsMaster
              };
              // console.log({updatedMasterData,updatedMasterDataNew});
              const formData = selectedTemplateToForm(
                jobOpportunityData,
                updatedMasterData,
                location.address
              );
              if (
                jobOpportunityData?.jobsProfileFormsList.length > 0 &&
                dynamicFormData?.length
              ) {
                const newDynamicFormData = patchDynamicForm(
                  dynamicFormData,
                  jobOpportunityData?.jobsProfileFormsList
                );
                dispatch(updateDynamicFormData(newDynamicFormData));
                //console.log(newDynamicFormData)
              }
              dispatch(
                updateRecusionFlag(
                  jobOpportunityData?.jobSummeryJobsShifts?.shiftType
                )
              );
              if (
                jobOpportunityData?.jobSummeryJobsShifts &&
                jobOpportunityData?.jobSummeryJobsShifts?.shiftType === 3
              ) {
                if (
                  jobOpportunityData?.jobSummeryJobsShifts?.recurrenceRule !==
                  ''
                ) {
                  const data = destructure(
                    jobOpportunityData?.jobSummeryJobsShifts?.recurrenceRule
                  );
                  if (data) {
                    dispatch(updaterecurrenceRule(data));
                  }
                }
              }
              dispatch(loadDataForEdit(formData));
            })
            .catch((error) => {
              dispatch(setFailureLogs(error.message));
            });
      }
      const payload = { field: field, data: value };
      dispatch(updateStartJobDetails(payload));
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
    // dispatch(setLoading(false));
  };
}

export function updateLocation(field, value) {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const payload = { field: field, data: value };
      dispatch(updateLocationDetails(payload));
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    }
    dispatch(setLoading(false));
  };
}

export function updateLocationContactPersons(category, action) {
  return (dispatch) => {
    switch (action) {
      case 'add':
        dispatch(addLocationContactPerson(category));
        break;
      case 'remove':
        dispatch(removeLocationContactPerson(category));
        break;
      default:
        break;
    }
  };
}

export function updateLocationApprovers(category, action) {
  return (dispatch) => {
    switch (action) {
      case 'add':
        dispatch(addLocationApprover(category));
        break;
      case 'remove':
        dispatch(removeLocationApprover(category));
        break;
      default:
        break;
    }
  };
}

export function updatecovidVaccination(covidVaccination, action) {
  return (dispatch) => {
    switch (action) {
      case 'add':
        dispatch(addcovidVaccination(covidVaccination));
        break;
      case 'remove':
        dispatch(removecovidVaccination(covidVaccination));
        break;
      default:
        break;
    }
  };
}

export function updateAutoRepost(value) {
  return (dispatch) => {
    dispatch(setAutoRepost(value))
  }
}

export function updateShift(field, value) {
  return async (dispatch, getState) => {
    const state = getState();
    const { shift, masterData,recursionFlag } = state.jobOpportunity;
    dispatch(setLoading(true));
    try {
      const payload = { field: field, data: value };
      dispatch(updateShiftDetails(payload));
      if (field === "preferedShift" && shift.startTime) {
        const result = updateShiftTime({ currentValue: value?.id, updateField: "endTime", shiftStartTime: shift?.startTime?.id, masterData: masterData?.allShiftEndTime , shiftStartDate:shift?.date, shiftType:recursionFlag});
        const payload = {field:result?.field,data:result?.data}
        const singleShiftEndDate = {field:"singleShiftEndDate",data:result?.singleShiftEndDate}
        dispatch(updateShiftDetails(payload));
        dispatch(updateShiftDetails(singleShiftEndDate));
      }
      if (field === "startTime" && shift?.preferedShift) {
        const result = updateShiftTime({ currentValue: shift?.preferedShift?.id, updateField: "endTime", shiftStartTime: value?.id, masterData: masterData?.allShiftEndTime , shiftStartDate:shift?.date, shiftType:recursionFlag});
        console.log({result});
        const payload = {field:result?.field,data:result?.data}
        const singleShiftEndDate = {field:"singleShiftEndDate",data:result?.singleShiftEndDate}
        dispatch(updateShiftDetails(payload));
        dispatch(updateShiftDetails(singleShiftEndDate));
      }
      if (field === "startTime" && !shift?.preferedShift?.id && shift?.endTime?.id) {
        const payload = updateShiftTime({ currentValue: shift?.endTime?.id, updateField: "preferedShift", shiftStartTime: value.id, masterData: masterData?.allPreferedShifts, shiftStartDate:shift?.date, shiftType:recursionFlag });
        dispatch(updateShiftDetails(payload));
      }
      if (field === "endTime" && shift.startTime) {
        const result = updateShiftTime({ currentValue: value?.id, updateField: "preferedShift", shiftStartTime: shift.startTime.id, masterData: masterData?.allPreferedShifts, shiftStartDate:shift?.date, shiftType:recursionFlag });
        const payload = {field:result?.field,data:result?.data}
        const singleShiftEndDate = {field:"singleShiftEndDate",data:result?.singleShiftEndDate}
        dispatch(updateShiftDetails(payload));
        dispatch(updateShiftDetails(singleShiftEndDate));

      }
      // if (field === 'startTime' && shiftLength && shiftLength > 0) {
      //   const endTime = moment(value?.name, 'hh:mm A')
      //     .add(shiftLength, 'hours')
      //     .subtract(0, 'minute')
      //     .format('hh:mm A');
      //   dispatch(
      //     updateShiftDetails({
      //       field: 'endTime',
      //       data: masterData?.allShiftEndTime?.find(
      //         (item) => item?.name === endTime
      //       ),
      //     })
      //   );
      // }
      // if (
      //   field === 'preferedShift' &&
      //   shift.startTime &&
      //   shift.startTime !== 'Select'
      // ) {
      //   const endTime = moment(shift?.startTime?.name, 'hh:mm A')
      //     .add(value.id, 'hours')
      //     .subtract(0, 'minute')
      //     .format('hh:mm A');
      //   dispatch(
      //     updateShiftDetails({
      //       field: 'endTime',
      //       data: masterData?.allShiftEndTime?.find(
      //         (item) => item?.name === endTime
      //       ),
      //     })
      //   );
      // }

    } catch (error) {
      dispatch(setFailureLogs(error.message));
    }
    dispatch(setLoading(false));
  };
}

export function updateJobInfoDetails(url, field, value) {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const payload = { field: field, data: value };
      dispatch(updateJobInfo(payload));
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    }
    dispatch(setLoading(false));
  };
}

export function updateTemplateDescJobInfo(url, template) {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const jobTemplateDescription = await requestUtil(
        `${url}/Employers/get-job-template-description/${template.id}`,
        'GET'
      );
      dispatch(
        updateJobInfo({
          field: 'jobDescription',
          data: jobTemplateDescription?.templateDescription,
        })
      );
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function setEducationDetails(educationDetails) {
  return (dispatch) => {
    dispatch(updateEducationInfo(educationDetails));
  };
}

export function setMedicalSpecialities(medicalDetails) {
  return (dispatch) => {
    dispatch(updateMedicalSpecialityInfo(medicalDetails));
  };
}

export function setCertification(certDetails) {
  return (dispatch) => {
    dispatch(updateCertificationInfo(certDetails));
  };
}

export function setEMREHRSystemExperience(sysExp) {
  return (dispatch) => {
    dispatch(updateEMREHRSystemExpInfo(sysExp));
  };
}

export function setCovidInfo(covidDetails) {
  return (dispatch) => {
    dispatch(updateCovidInfo(covidDetails));
  };
}

export function setTemplateInfo(templateInfo) {
  return (dispatch) => {
    dispatch(
      updateTemplateInfo({
        name: templateInfo?.name,
        value: templateInfo?.value,
      })
    );
  };
}

export function setErrorInfo(errors) {
  return (dispatch) => {
    dispatch(updateErrors(errors));
  };
}

export function setSaveAPIErrors(errors) {
  return async (dispatch) => {
    dispatch(updateJobSaveAPIErrors(errors));
  };
}

export function pushToSummary(
  jobType,
  startJob,
  location,
  shift,
  jobInfo,
  education,
  medicalSpeciality,
  certification,
  emrEhrSystemExperience,
  covidVaccinationStatus,
  templateInfo,
  employerUniqueId,
  formdata,
  rrurle,
  recursionFlag,
  rrurleStr,
  JobEncounterOccurreneUpdateList,
  isAutoPostAllowed,
  isOvertimeAllowed,
  depsUnits,
  payRateType,
  payRateTotalShiftAmount,
  payRateOccurrenceAmount
) {
  return async (dispatch) => {
    console.log({summm:depsUnits});
    dispatch(setLoading(true));
    try {
      dispatch(
        updateJobDetails({
          data: formToSummary(
            jobType,
            startJob,
            location,
            shift,
            jobInfo,
            education,
            medicalSpeciality,
            certification,
            emrEhrSystemExperience,
            covidVaccinationStatus,
            templateInfo,
            employerUniqueId,
            formdata,
            rrurle,
            recursionFlag,
            rrurleStr,
            JobEncounterOccurreneUpdateList,
            isAutoPostAllowed,
            isOvertimeAllowed,
            depsUnits,
            payRateType,
            payRateTotalShiftAmount,
            payRateOccurrenceAmount
          ),
          backPath: '/jobopportunity',
          editMode: true,
          jobId: undefined,
        })
      );
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    }
    dispatch(setLoading(false));
  };
}

export function saveJobInfo(
  url,
  jobType,
  startJob,
  location,
  shift,
  jobInfo,
  education,
  medicalSpeciality,
  certification,
  emrEhrSystemExperience,
  covidVaccinationStatus,
  templateInfo,
  employerId,
  loadJobId,
  navigateToMatchingCandidate,
  saveType,
  filterJobList,
  formdata,
  recursionFlag,
  rrurle,
  jobMultishiftOccurreneUpdateList,
  JobEncounterOccurreneUpdateList,
  jobUnique,
  jobCode,
  encounterCalculation,
  isAutoPostAllowed,
  isOvertimeAllowed,
  depsUnits,
  payRateType,
  payRateTotalShiftAmount,
  payRateOccurrenceAmount
) {
  // console.log({depsUnits});
  return async (dispatch, getState) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());
    const state = getState();
    const { masterData } = state.jobOpportunity;
    try {
      const payload = saveJobOpportunity(
        jobType,
        startJob,
        location,
        shift,
        jobInfo,
        education,
        medicalSpeciality,
        certification,
        emrEhrSystemExperience,
        covidVaccinationStatus,
        templateInfo,
        employerId,
        loadJobId,
        saveType,
        filterJobList,
        formdata,
        recursionFlag,
        rrurle,
        jobMultishiftOccurreneUpdateList,
        JobEncounterOccurreneUpdateList,
        masterData,
        encounterCalculation,
        isAutoPostAllowed,
        isOvertimeAllowed,
        depsUnits,
        payRateType,
        payRateTotalShiftAmount,
        payRateOccurrenceAmount
      );
      let jobData;
      if (saveType === 3) {
        delete payload.HourlyBillingRate;
        delete payload?.isOvertimeAllowed;
        const response = await requestUtil(
          `${url}/Employers/createjobtemplate`,
          'POST',
          payload
        );
        const newVal = JSON.parse(JSON.stringify(formdata));
        newVal.forEach((item) => {
          item.controlsInfo.forEach((val) => {
            val.selectedValueOptions = [];
          });
        });
        dispatch(updateDynamicFormData(newVal));
        return response
      } else {
        if (loadJobId) {
          jobData = await requestUtil(`${url}/employers/jobs/update`, 'POST', {
            ...payload,
            jobCode,
            jobUniqueId: jobUnique,
          });
          Toasts.success(jobData?.message)
        } else {
          if (parseInt(recursionFlag) === 2 && saveType !== 3) {
            const response = await requestUtil(`${url}/Employers/jobs/save-daily-encounter`, 'POST',
              payload);
            Toasts.success(response?.message)
            return response
          } else {
            jobData = await requestUtil(
              `${url}/Employers/jobs/save`,
              'POST',
              payload
            );
          }

        }

        const newVal = JSON.parse(JSON.stringify(formdata));
        newVal.forEach((item) => {
          item.controlsInfo.forEach((val) => {
            val.selectedValueOptions = [];
          });
        });
        dispatch(updateDynamicFormData(newVal));
        if (jobData && jobData?.jobsShiftUniqueId && jobData.jobUniqueId) {
          dispatch(
            setMatchingCandidateData({
              matchingJobID: jobData.jobsShiftUniqueId,
              navigate: navigateToMatchingCandidate,
              editJobUniqueId: jobData.jobUniqueId,
            })
          );
        }
        if (
          jobData?.encounterOccurrenceJson &&
          jobData?.encounterOccurrenceJson.length
        ) {
          dispatch(
            setJobEncounterOccurreneUpdateList(
              JSON.parse(
                JSON.stringify(
                  jobData?.encounterOccurrenceJson.map((element, index) => {
                    return {
                      Start: element.start,
                      End: element.end,
                      isAllDay: element.isAllDay,
                      // Title: element.title,
                      AppointmentType: element.appointmentType,
                      ShiftLength: element.shiftLength,
                      PatientName: element.patientName,
                      PatientPhone: element.patientPhone,
                      PatientStreetAddress: element.patientStreetAddress,
                      PatientZipCode: element.patientZipCode,
                      // MapDetails: element.mapDetails,
                      TaskID: element.taskId,
                      PatientState: element.PatientState,
                      PatientCity: element.PatientCity,
                      billingRate: element.billingRate,
                    };
                  })
                )
              )
            )
          );
        }
      }
    } catch (error) {
      dispatch(setFailureLogs(error.message));
      dispatch(updateJobSaveAPIErrors(error.message));
      Toasts.error(error?.message)
      return error
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export const updateMatchingCandidateData = (
  matchingJobID,
  navigateToMatchingCandidate
) => {
  return async (dispatch) => {
    dispatch(
      setMatchingCandidateData({ matchingJobID, navigateToMatchingCandidate })
    );
  };
};

export function resetJobOpportunityInfo() {
  return async (dispatch) => {
    dispatch(resetJobOpportunity());
  };
}

export function loadMasterData(baseUrl, employerUniqueId, val) {
  return async (dispatch, getState) => {
    // dispatch(setLoading(true));
    const state = getState();
    const locationSharedList = state.shared.locationSharedList;
    const shiftStartTimeList = state.shared.shiftStartTimeList;
    const shiftEndTimeList = state.shared.shiftEndTimeList;
    const shiftLengthSharedList = state.shared.shiftLengthSharedList;
    const covidVaccineSharedList = state.shared.covidVaccineSharedList;
    const spokenLanguageSharedList = state.shared.spokenLanguageSharedList;
    let jobLocations = locationSharedList ?? [];
    let covidVaccinationOptions = covidVaccineSharedList ?? [];
    let spokenLanguages = spokenLanguageSharedList ?? [];
    let shiftStartTime = shiftStartTimeList ?? [];
    let shiftEndTime = shiftEndTimeList ?? [];
    let shiftPreferedTime = shiftLengthSharedList ?? [];
    try {
    dispatch(setLoadingFlagIncrement());
      const jobDomains = await requestUtil(
        `${baseUrl}/Employers/getjobdomain/${employerUniqueId}`,
        'POST',
        {}
      );
      const jobTypes = await requestUtil(
        `${baseUrl}/Employers/getjobtypes/${employerUniqueId}`,
        'POST',
        {}
      );
      const jobTemplates = await requestUtil(
        `${baseUrl}/Employers/get-employer-job-templates`,
        'POST',
        {
          employerUniqueId: employerUniqueId,
        }
      );
      if(jobLocations?.length === 0){
         jobLocations = await requestUtil(
          `${baseUrl}/Locations/get-location-list-for-dropdown/${employerUniqueId}`,
          'GET'
        );
        dispatch(updateSharedSlice({name:'locationSharedList', value:jobLocations}));
      }
      if(covidVaccinationOptions?.length === 0){
         covidVaccinationOptions = await requestUtil(`${baseUrl}/Dropdown/GetCovidvaccinated`,'GET');
         dispatch(updateSharedSlice({name:'covidVaccineSharedList', value:covidVaccinationOptions}));
      }
      if(spokenLanguages?.length === 0){
         spokenLanguages = await requestUtil(`${baseUrl}/Dropdown/GetSpokenLanguages`,'GET');
         dispatch(updateSharedSlice({name:'spokenLanguageSharedList', value:spokenLanguages}));
      }
      const jobID = 1;
      // const educationLevels = await requestUtil(`${baseUrl}/Dropdown/GetLevelOfEducations`, 'GET');
      //  const specialities = await requestUtil(`${baseUrl}/Dropdown/getspecialties/${val}`, 'GET');
      // const certifications = await requestUtil(`${baseUrl}/Dropdown/getcertifications/${val}`, 'GET');
      //const emrEhrSystemExp = await requestUtil(`${baseUrl}/Dropdown/getemrehrsystems/${val}`, 'GET');
      if(shiftStartTime?.length === 0){
        const shiftStartTimeResponse =  await requestUtil(`${baseUrl}/Dropdown/get-shift-start-time`,'GET');
        shiftStartTime = shiftStartTimeResponse?.shiftTimeList?.map((item) => {
          return { name: item.displayText, id: item.time };
        })
        console.log({shiftStartTime});
        dispatch(updateSharedSlice({name:'shiftStartTimeList', value:shiftStartTime}));
      }
      if(shiftEndTime?.length === 0) {
        const shiftEndTimeResponse = await requestUtil(`${baseUrl}/Dropdown/get-shift-end-time`,'GET');
        shiftEndTime = shiftEndTimeResponse?.shiftTimeList?.map((item) => {
          return { name: item.displayText, id: item.time };
        })
        dispatch(updateSharedSlice({name:'shiftEndTimeList', value: shiftEndTime}));
      }
      if(shiftPreferedTime?.length === 0){
         shiftPreferedTime = await requestUtil(`${baseUrl}/Dropdown/get-shift-length-for-new-job`,'GET');
        dispatch(updateSharedSlice({name:'shiftLengthSharedList', value: shiftPreferedTime}));
      }
      const getAppointmentData = await requestUtil(
        `${baseUrl}/Dropdown/getappointmenttype?EmployerUniqueId=${employerUniqueId}`,
        'GET'
      );
      const getShiftLengthData = await requestUtil(
        `${baseUrl}/Dropdown/getshiftlength`,
        'GET'
      );

      dispatch(
        setMasterData({
          jobDomains: jobDomains,
          jobTypes: jobTypes,
          jobTemplates: jobTemplates,
          jobLocations: jobLocations,
          shiftStartTime:shiftStartTime,
          shiftEndTime: shiftEndTime,
          shiftPreferedTime: shiftPreferedTime,
          spokenLanguages: spokenLanguages,
          covidVaccinationOptions: covidVaccinationOptions,
          // educationLevels: educationLevels,
          // certifications: certifications,
          // specialities: specialities,
          // emrEhrSystemExp: emrEhrSystemExp
          jobID: jobID,
        })
      );
      dispatch(
        setCalenderData({
          appointmentData: getAppointmentData,
          shiftLengthData: getShiftLengthData,
        })
      );
    } catch (error) {
      dispatch(
        setFailureLogs(error.message || 'Error while loading master data')
      );
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
    // dispatch(setLoading(false));
  };
}
export function updateemrEhrSystemExpInMasterData(url, field, value) {
  return async (dispatch) => {
    //console.log("emr ehr:", value.id);
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const emrEhrSystemExp = await requestUtil(
        `${url}/Dropdown/getemrehrsystems/${value.id}`,
        'GET'
      );
      dispatch(updateJobemrEhrSystemExpMasterData(emrEhrSystemExp));
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function updatecertificationsInMasterData(url, field, value) {
  return async (dispatch) => {
    //console.log("Certification ID", value.id);
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const certifications = await requestUtil(
        `${url}/Dropdown/getcertifications/${value.id}`,
        'GET'
      );
      dispatch(updateJobcertificationsMasterData(certifications));
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}
export function updatespecialitiesInMasterData(url, field, value) {
  return async (dispatch) => {
    //console.log("Sp ID", value.id);
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const specialities = await requestUtil(
        `${url}/Dropdown/getspecialties/${value.id}`,
        'GET'
      );
      dispatch(updateJobspecialitiesMasterData(specialities));
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function updateJobCategoryInMasterData(url, field, value) {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const jobOpportunityDetails = await requestUtil(
        `${url}/Dropdown/getjobcategories/${value.id}`,
        'GET'
      );
      dispatch(updateJobCategoryMasterData(jobOpportunityDetails));
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}
export function updateEducationLevelInMasterData(url, field, value) {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const educationLevelDetails = await requestUtil(
        `${url}/Dropdown/GetLevelOfEducationsV2/${value.id}`,
        'GET'
      );
      dispatch(updateEducationLevelMasterData(educationLevelDetails));
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function updateLocationDropdownsInMasterData(url, locationId) {
  return async (dispatch, getState) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());

    try {

      const state = getState();
      const { masterData } = state.jobOpportunity;

      const locationDetails = await requestUtil(
        `${url}/Locations/getlocationdetail?locationId=${locationId}`,
        'GET'
      );
      const contactsForLocation = await requestUtil(
        `${url}/Locations/get-contacts-for-dropdown/?Locationid=${locationId}`,
        'POST'
      );
      const approversForLocation = await requestUtil(
        `${url}/Locations/getapprovalusers?Locationid=${locationId}`,
        'POST'
      );

      if (locationDetails && locationDetails?.acceptableTravelDistance) {
        dispatch(setDistance(locationDetails?.acceptableTravelDistance));
      }
      dispatch(
        updateLocationAddress({
          locationName: locationDetails?.locationName,
          zipcode: locationDetails?.zipcode,
          city: locationDetails?.city,
          stateName: locationDetails?.stateName,
          country: locationDetails?.country,
          latitude: locationDetails?.approxLatitude,
          longitude: locationDetails?.approxLongitude,
          streetAddress: locationDetails?.streetAddress,
        })
      );

      dispatch(clearContactAndApprovalUser());
      if (
        contactsForLocation.length === 0 ||
        approversForLocation.length === 0
      ) {
        dispatch(setDisplayContactApprovererror(true));
      }
      dispatch(
        updateLocationContactsInMasterData({
          contacts: contactsForLocation,
          approvers: approversForLocation,
        })
      );
      if (masterData?.calendarJobLocationContactPersons?.length === 0 &&
        masterData?.calendarobLocationApprovers?.length === 0) {
        dispatch(
          updateCalendarLocationDetail({
            contacts: contactsForLocation,
            approvers: approversForLocation,
          })
        );
      }
      return {
        contactsForLocation,
        approversForLocation,
        address: {
          locationName: locationDetails?.locationName,
          zipcode: locationDetails?.zipcode,
          city: locationDetails?.city,
          stateName: locationDetails?.stateName,
          country: locationDetails?.country,
          latitude: locationDetails?.approxLatitude,
          longitude: locationDetails?.approxLongitude,
          streetAddress: locationDetails?.streetAddress,
        },
      };
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function loadJobToEdit(url, jobId) {
  return async (dispatch, getState) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const state = getState();
      const { masterData, formdata, jobInfo } = state.jobOpportunity;
      const {depsUnitsMaster} = state.login;
      const jobDetails = await requestUtil(
        `${url}/Employers/jobs/edit/${jobId}`,
        'GET'
      );
      const contactsForLocation = await requestUtil(
        `${url}/Locations/get-contacts-for-dropdown/?Locationid=${jobDetails?.employerJobLocationsList[0]?.locationId}`,
        'POST'
      );
      const approversForLocation = await requestUtil(
        `${url}/Locations/getapprovalusers?Locationid=${jobDetails?.employerJobLocationsList[0]?.locationId}`,
        'POST'
      );

      let educationLevelDetails = [];
      let jobOpportunityDetails = [];
      let emrEhrSystemExp = [];
      let certifications = [];
      let specialities = [];
      let dynamicFormData = []

      if (masterData?.allJobTypes.length > 1) {
        educationLevelDetails = await requestUtil(
          `${url}/Dropdown/GetLevelOfEducationsV2/${jobDetails?.jobTypeID}`,
          'GET'
        );
        jobOpportunityDetails = await requestUtil(
          `${url}/Dropdown/getjobcategories/${jobDetails?.jobTypeID}`,
          'GET'
        );
        // emrEhrSystemExp = await requestUtil(
        //   `${url}/Dropdown/getemrehrsystems/${jobDetails?.jobTypeID}`,
        //   'GET'
        // );
        // certifications = await requestUtil(
        //   `${url}/Dropdown/getcertifications/${jobDetails?.jobTypeID}`,
        //   'GET'
        // );
        // specialities = await requestUtil(
        //   `${url}/Dropdown/getspecialties/${jobDetails?.jobTypeID}`,
        //   'GET'
        // );
        
        const dynamicform = await requestUtil(
          `${url}/Employers/get-dynamic-QA-for-job-creation`,
          'POST',
          { jobLevel: [jobDetails?.jobCategoryId] }
        );
        if (dynamicform?.tabsList) {
          dynamicFormData = dynamicform?.tabsList
        }
        dispatch(updateEducationLevelMasterData(educationLevelDetails));
        dispatch(updateJobCategoryMasterData(jobOpportunityDetails));
        // dispatch(updateJobcertificationsMasterData(certifications));
        // dispatch(updateJobspecialitiesMasterData(specialities));
        // dispatch(updateJobemrEhrSystemExpMasterData(emrEhrSystemExp));
        dispatch(updateDropDownJobId(jobDetails?.jobTypeID));
        if (dynamicform?.tabsList) {
          dispatch(setFormData(dynamicform?.tabsList));
        }
      } else {
        dynamicFormData = formdata
      }
      const jobIdFlag = JSON.parse(sessionStorage.getItem("login"));
      if(jobDetails?.jobCategoryId && !jobIdFlag?.accountFlags?.isShowQATab){
        const params = {
          jobLevel:[jobDetails?.jobCategoryId]
        };
         emrEhrSystemExp = await requestUtil(
          `${url}/Dropdown/Get-New-EMREHRSystems-byJobLevel`,
          'POST',{...params}
        );
         certifications = await requestUtil(
          `${url}/Dropdown/Get-New-Certifications-byJobLevel`,
          'POST',{...params}
        );
         specialities = await requestUtil(
          `${url}/Dropdown/Get-New-Specialties-byJobLevel`,
          'POST',{...params}
        );
        dispatch(updateJobcertificationsMasterData(certifications));
        dispatch(updateJobspecialitiesMasterData(specialities));
        dispatch(updateJobemrEhrSystemExpMasterData(emrEhrSystemExp));
      }
      dispatch(
        updateLocationContactsInMasterData({
          contacts: contactsForLocation,
          approvers: approversForLocation,
        })
      );
      // if (masterData?.calendarJobLocationContactPersons?.length === 0 &&
      //   masterData?.calendarobLocationApprovers?.length === 0) {
      //   dispatch(
      //     updateCalendarLocationDetail({
      //       contacts: contactsForLocation,
      //       approvers: approversForLocation,
      //     })
      //   );
      // }
      const updateMasterData = {
        allEducationLevels: [...educationLevelDetails],
        allJobCategory: [...jobOpportunityDetails],
        allCertifications: [...certifications],
        allMedicalSpecialities: [...specialities],
        allEmrEhrSystemExperience: [...emrEhrSystemExp],
        depsUnitsMaster
      };
      const newMasterData = { ...masterData, ...updateMasterData };
      const formData = summaryToForm(jobDetails, newMasterData);
      if (jobDetails?.jobProfileForms?.length > 0 && dynamicFormData?.length) {
        const newDynamicFormData = patchDynamicForm(
          dynamicFormData,
          jobDetails?.jobProfileForms
        );
        dispatch(updateDynamicFormData(newDynamicFormData));
        //console.log(newDynamicFormData)
      }
      dispatch(updateRecusionFlag(jobDetails?.jobSummeryJobsShifts?.shiftType));
      if (
        jobDetails?.jobSummeryJobsShifts &&
        jobDetails?.jobSummeryJobsShifts?.shiftType === 3
      ) {
        if (jobDetails?.jobSummeryJobsShifts?.recurrenceRule !== '') {
          dispatch(setrrule(jobDetails?.jobSummeryJobsShifts?.recurrenceRule));
          const data = destructure(
            jobDetails?.jobSummeryJobsShifts?.recurrenceRule
          );
          const str = convertToString(
            jobDetails?.jobSummeryJobsShifts?.recurrenceRule
          );
          dispatch(updateRruleStr(str));
          if (data) {
            dispatch(updaterecurrenceRule(data));
          }
        }
      }
      if (jobDetails?.occurrenesJson && jobDetails?.occurrenesJson.length) {
        const jobMultishiftOccurreneUpdateListObj =
          jobDetails?.occurrenesJson.map((element, index) => {
            const calenderRequestBody = {
              TaskID: element.taskId,
              ownerID: element.ownerID,
              Title: element.title,
              Description: element.description,
              StartTimezone: null,
              Start: element.start,
              End: element.end,
              EndTimezone: null,
              RecurrenceRule: element.recurrenceRule,
              RecurrenceID: element.recurrenceID,
              RecurrenceException: element.recurrenceException,
              isAllDay: element.isAllDay,
              editDay: element.editDay,
              locationId: element.locationId,
              jobsContactsList: element.jobsContactsList?.length ? element.jobsContactsList : [],
              jobsApproversList: element.jobsApproversList?.length ? element.jobsApproversList : [],
              billingrate: element?.billingrate ? element?.billingrate : '',
              shiftLength: element.shiftLength ? element.shiftLength : '',
              payRateOccurrenceAmount: element?.manualAmountPerShift ?? null,
            };
            return calenderRequestBody;
          });
        // console.log(jobMultishiftOccurreneUpdateListObj);
        dispatch(
          setjobMultishiftOccurreneUpdateList(
            jobMultishiftOccurreneUpdateListObj
          )
        );
      }
      if (
        jobDetails?.encounterOccurrenceJson &&
        jobDetails?.encounterOccurrenceJson.length
      ) {
        dispatch(
          setJobEncounterOccurreneUpdateList(
            JSON.parse(
              JSON.stringify(
                jobDetails?.encounterOccurrenceJson.map((element, index) => {
                  return {
                    Start: element.start,
                    End: element.end,
                    isAllDay: element.isAllDay,
                    // Title: element.title,
                    AppointmentType: element.appointmentType,
                    ShiftLength: element.shiftLength,
                    PatientName: element.patientName,
                    PatientPhone: element.patientPhone,
                    PatientStreetAddress: element.patientStreetAddress,
                    PatientZipCode: element.patientZipCode,
                    // MapDetails: element.mapDetails,
                    TaskID: element.taskId,
                    PatientState: element.patientState,
                    PatientCity: element.patientCity,
                    billingRate: element.billingRate,
                    jobsClaimId: element?.jobsClaimId,
                    incentive: element?.incentive
                  };
                })
              )
            )
          )
        );
      }
      dispatch(loadDataForEdit(formData));
      dispatch(
        setSelectedOption({
          newPost: false,
          fromTemplate: false,
          createTemplate: false,
          editJobPost: true,
        })
      );
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setFailureLogs(error.message));
      // setLoading(false);
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}
export function setJobId(jobId) {
  return async (dispatch) => {
    dispatch(loadJobId(jobId));
  };
}

export function setAcceptableDistance(acceptableTravelDistance) {
  return async (dispatch) => {
    dispatch(setDistance(acceptableTravelDistance));
  };
}

export function editPost() {
  return async (dispatch) => {
    dispatch(
      setSelectedOption({
        newPost: false,
        fromTemplate: false,
        createTemplate: false,
        editJobPost: true,
      })
    );
  };
}
export function startNewPost() {
  return async (dispatch) => {
    dispatch(
      setSelectedOption({
        newPost: true,
        fromTemplate: false,
        createTemplate: false,
        editJobPost: false,
      })
    );
    dispatch(setResetDropdown(true));
  };
}
export function startWithTemplate() {
  return async (dispatch) => {
    dispatch(
      setSelectedOption({
        newPost: false,
        fromTemplate: true,
        createTemplate: false,
        editJobPost: false,
      })
    );
    dispatch(setResetDropdown(true));
  };
}
export function createTemplate() {
  return async (dispatch) => {
    dispatch(
      setSelectedOption({
        newPost: false,
        fromTemplate: false,
        createTemplate: true,
        editJobPost: false,
      })
    );
    dispatch(setResetDropdown(true));
  };
}

export const updateDropDownJobId = (id) => {

  return async (dispatch) => {
    dispatch(setDropdownJobId(id));
  };
};

export const getDynamicFormData = ({ url, jobLevel }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(
        `${url}/Employers/get-dynamic-QA-for-job-creation`,
        'POST',
        { jobLevel }
      );
      //const res = JSON.parse(JSON.stringify(response));
      //delete res.sections;
      // console.log(res);
      //console.log(response);
      if (response?.tabsList) {
        dispatch(setFormData(response?.tabsList));
      }
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const updateDynamicFormData = (data) => {
  return async (dispatch) => {
    dispatch(setFormData(data));
  };
};

export const getRatePerHour = ({ url, params }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());
    // Its a old Method get-hourly-rate
    try {
      const { employerUniqueId, startTime, endTime, recursionFlag, shiftDate, ...rest } = params;
      // const response = await requestUtil(
      //   `${url}/Employers/get-hourly-rate`,
      //   'POST',
      //   { ...rest, employerUniqueId }
      // );
      // if (response?.getHourlyRates) {
      //   dispatch(
      //     updateJobInfo({
      //       field: 'ratePerHour',
      //       data: response?.getHourlyRates?.hourlyPayRate,
      //     })
      //   );
      //   dispatch(
      //     updateJobInfo({
      //       field: 'billingrate',
      //       data: response?.getHourlyRates?.billingRate,
      //     })
      //   );
      if (parseInt(recursionFlag) === 1 || parseInt(recursionFlag) === 3) {
        const response = await requestUtil(
          `${url}/Employers/get-variable-payrate`,
          'POST',
          { ...rest, startTime, endTime, shiftDate }
        );
        if (response?.getHourlyRates?.billingRate) {
          dispatch(
            updateJobInfo({
              field: 'billingrate',
              data: response?.getHourlyRates?.billingRateToDispaly,
            })
          );
          dispatch(
            updateJobInfo({
              field: 'restoreBillingrate',
              data: response?.getHourlyRates?.billingRateToDispaly,
            })
          );
          dispatch(
            updateJobInfo({
              field: 'shiftamount',
              data: parseFloat(response?.getHourlyRates?.billingRate),
            })
          );
          dispatch(
            updateJobInfo({
              field: 'billingRateParam',
              data: parseFloat(response?.getHourlyRates?.billingRate),
            })
          );
          dispatch(
            updateJobInfo({
              field: 'mileage',
              data: response?.mileage,
            })
          );
          dispatch(
            updateJobInfo({
              field: 'payRates',
              data: response?.payRates,
            })
          );
          dispatch(
            updateJobInfo({
              field: 'ratePerHour',
              data: response?.getHourlyRates?.hourlyPayRate,
            })
          );
        } else {

          dispatch(resetShiftAmount())

        }
      } else {
        const response = await requestUtil(
          `${url}/Employers/get-hourly-rate`,
          'POST',
          { ...rest, employerUniqueId }
        );
        if (response?.getHourlyRates) {
          dispatch(
            updateJobInfo({
              field: 'ratePerHour',
              data: response?.getHourlyRates?.hourlyPayRate,
            })
          );
          dispatch(
            updateJobInfo({
              field: 'billingrate',
              data: response?.getHourlyRates?.billingRate,
            })
          );
          dispatch(
            updateJobInfo({
              field: 'mileage',
              data: response?.mileage,
            })
          );
          dispatch(
            updateJobInfo({
              field: 'payRates',
              data: response?.payRates,
            })
          );
        }
      }
    } catch (error) {
      dispatch(resetShiftAmount())
      dispatch(setFailureLogs(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const updateRecusionFlag = (data) => {
  return async (dispatch) => {
    dispatch(setreursionFlag(data));
  };
};

export const updateRepeat = (data) => {
  return async (dispatch) => {
    dispatch(setrepeatEvery(data));
  };
};

export const updateWeek = (data) => {
  return async (dispatch) => {
    dispatch(setWeeks(data));
  };
};

export const updateMonth = (data) => {
  return async (dispatch) => {
    dispatch(setMonth(data));
  };
};

export const updateYear = (data) => {
  return async (dispatch) => {
    dispatch(setYear(data));
  };
};

export const recurrenceStructring = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const { repeatEvery, shift, byWeeks, byMonths, byYear } =
      state.jobOpportunity;
    // console.log(byWeeks, '====');
    if (repeatEvery && repeatEvery?.type === 'DAILY') {
      const data = structure(repeatEvery, '', shift?.endDate);
      dispatch(setrrule(data));
      const str = convertToString(data);
      dispatch(updateRruleStr(str));
    } else if (repeatEvery && repeatEvery?.type === 'WEEKLY' && byWeeks) {
      const data = structure(repeatEvery, byWeeks, shift?.endDate, shift?.startTime?.id);
      // console.log(data, '---->');
      dispatch(setrrule(data));
      const str = convertToString(data);
      dispatch(updateRruleStr(str));
    } else if (repeatEvery && repeatEvery?.type === 'MONTHLY' && byMonths) {
      const data = structure(repeatEvery, byMonths, shift?.endDate);
      dispatch(setrrule(data));
      const str = convertToString(data);
      dispatch(updateRruleStr(str));
    } else if (repeatEvery && repeatEvery?.type === 'YEARLY' && byYear) {
      const data = structure(repeatEvery, byYear, shift?.endDate);
      // console.log(data)
      dispatch(setrrule(data));
      const str = convertToString(data);
      dispatch(updateRruleStr(str));
    }
  };
};

const updaterecurrenceRule = (data) => {
  return async (dispatch) => {
    // console.log(data)
    if (data && data?.repeat && data?.fullData) {
      const payload = { data: data?.repeat, fullData: data?.fullData };
      dispatch(updateRepeat(payload));
    }

    if (data && data?.enddate !== '') {
      dispatch(updateShift('endDate', data?.enddate));
    }

    if (data && data?.type === 'WEEKLY' && data?.week) {
      dispatch(updateWeek(data?.week));
    } else if (data && data?.type === 'MONTHLY' && data?.fullData) {
      if (data?.subtype === 'onday') {
        const payload = { type: data?.subtype, data: data?.onday };
        dispatch(updateMonth(payload));
      } else if (data?.subtype === 'onthe') {
        const payload = {
          type: data?.subtype,
          data: data?.onthe,
          fullData: data?.fullData,
        };
        dispatch(updateMonth(payload));
      }
    } else if (data && data?.type === 'YEARLY' && data?.fullData) {
      if (data?.subtype === 'on') {
        const payload = {
          type: data?.subtype,
          data: data?.on,
          fullData: data?.fullData,
        };
        dispatch(updateYear(payload));
      } else if (data?.subtype === 'onthe') {
        const payload = {
          type: data?.subtype,
          data: data?.onthe,
          fullData: data?.fullData,
        };
        dispatch(updateYear(payload));
      }
    }
  };
};

const updateRruleStr = (data) => {
  return async (dispatch) => {
    dispatch(setrruleStr(data));
  };
};

export function getZipCodeInfo(url, zipcode) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${url}/Zipcodes/getzipcodeinfo/${zipcode}`,
        'GET'
      );
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function getEncounterRate(url, params) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${url}/Employers/get-encounter-rate`,
        'POST',
        { ...params }
      );
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export const updateBillingRate = (data) => {
  return async (dispatch) => {
    dispatch(
      updateJobInfo({
        field: 'billingrate',
        data: data,
      })
    );
  };
};
export const getMultishiftAmount = ({ url, shiftAmountMultishiftOccurrence, params }) => {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const multishifOccurrenceParam = shiftAmountMultishiftOccurrence.length
        ? shiftAmountMultishiftOccurrence.map((element, index) => {
          return {
            ownerID: element.ownerID,
            taskID: typeof element.TaskID === 'number' ? element.TaskID : 0,
            title: element.Title,
            description: element.Description,
            startTime: moment(element.Start).format('h:mm A'),
            endTime: moment(element.End).format('h:mm A'),
            // start: moment.tz(fromDate, login?.timeZoneShort).utc().format(),
            // end: moment.tz(toDate, login?.timeZoneShort).utc().format(),
            start: moment(element.Start).utc().format(),
            end: moment(element.End).utc().format(),
            StartText: moment(element.Start).format('YYYY-MM-DDTHH:mm:ss'),
            EndText: moment(element.End).format('YYYY-MM-DDTHH:mm:ss'),
            recurrenceRule: element.RecurrenceRule,
            recurrenceException:
              element.RecurrenceException &&
                element.RecurrenceException.length
                ? element.RecurrenceException.map((dateElement, index) => {
                  return moment
                    .tz(dateElement, login?.timeZoneShort)
                    .utc()
                    .format();
                })
                : element.RecurrenceException,
            recurrenceID: !element.RecurrenceID
              ? element.RecurrenceID
              : typeof element.RecurrenceID === 'number'
                ? element.RecurrenceID
                : 0,
            isAllDay: element.isAllDay,
            editDay: element.editDay,
            jobsContactsList: element?.jobsContactsList,
            jobsApproversList: element?.jobsApproversList,
            billingrate: element?.billingrate?.toString(),
            shiftLength: element.shiftLength,
            locationId: element?.locationId
          };
        })
        : []
      const response = await requestUtil(`${url}/Employers/get-multishift-shiftamount`, 'POST', { ...params, jobMultishiftOccurreneUpdateList: multishifOccurrenceParam }
      );
      if (response) {
        dispatch(
          updateJobInfo({
            field: 'shiftamount',
            data: response?.employerShiftAmount,
          })
        );

        if (parseInt(response?.employerShiftAmount) === 0) {
          dispatch(
            updateJobInfo({
              field: 'total',
              data: response?.employerShiftAmount,
            })
          )
        }
      }
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const getAuthUsers = (url, payload) => {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${url}/EmployersEncounter/get-authorized-users`,
        'POST',
        { ...payload }
      );
      return response
      // console.log(response);
    } catch (error) {
      return error
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export const getFilterDailyEncounter = (url, requestJson) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(
        `${url}/EmployersEncounter/get-scheduled-encounters-for-create`,
        'POST',
        { ...requestJson }
      );
      if (
        response?.EncounterOccurences &&
        response?.EncounterOccurences.length
      ) {
        dispatch(
          setJobEncounterOccurreneUpdateList(JSON.parse(JSON.stringify([])))
        );
        dispatch(setGrouping({ key: 'group', value: [] }));
        dispatch(setGrouping({ key: 'resources', value: [] }));

        dispatch(
          setJobEncounterOccurreneUpdateList(
            JSON.parse(
              JSON.stringify(
                response?.EncounterOccurences.map((element, index) => {
                  return {
                    Start: element.start,
                    End: element.end,
                    isAllDay: element.isAllDay,
                    // Title: element.title,
                    AppointmentType: element.appointmentType,
                    ShiftLength: element.shiftLength,
                    PatientName: element.patientName,
                    PatientPhone: element.patientPhone,
                    PatientStreetAddress: element.patientStreetAddress,
                    PatientZipCode: element.patientZipCode,
                    // MapDetails: element.mapDetails,
                    TaskID: element.taskId,
                    PatientState: element.patientState,
                    PatientCity: element.patientCity,
                    billingRate: element.billingRate,
                    jobsClaimId: element.jobsClaimId
                      ? element.jobsClaimId
                      : null,
                    isUnclaimedOccurrence: element.isUnclaimedOccurrence,
                    ShiftUniqueId: element.shiftUniqueId,
                    candidateUniqueId: element.candidateUniqueId,
                    IsClaimed: element.isClaimed,
                    isCheckedIn: element?.isCheckedIn,
                    isCheckedOut: element?.isCheckedOut,
                    isNewSlot: false,
                    incentive: element?.incentive
                  };
                })
              )
            )
          )
        );
      }
      // dispatch(setLoading(false));
      return response.Resources;
    } catch (error) {
      Toasts.error(error?.message);
    }
    finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export function calendaeLocationDetails(url, locationId) {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {

      //   `${url}/Locations/getlocationdetail?locationId=${locationId}`,
      //   'GET'
      // );
      const contactsForLocation = await requestUtil(
        `${url}/Locations/get-contacts-for-dropdown/?Locationid=${locationId}`,
        'POST'
      );
      const approversForLocation = await requestUtil(
        `${url}/Locations/getapprovalusers?Locationid=${locationId}`,
        'POST'
      );

      // if (locationDetails && locationDetails?.acceptableTravelDistance) {
      //   dispatch(setDistance(locationDetails?.acceptableTravelDistance));
      // }
      // dispatch(
      //   updateLocationAddress({
      //     locationName: locationDetails?.locationName,
      //     zipcode: locationDetails?.zipcode,
      //     city: locationDetails?.city,
      //     stateName: locationDetails?.stateName,
      //     country: locationDetails?.country,
      //     latitude: locationDetails?.approxLatitude,
      //     longitude: locationDetails?.approxLongitude,
      //     streetAddress: locationDetails?.streetAddress,
      //   })
      // );



      dispatch(
        updateCalendarLocationDetail({
          contacts: contactsForLocation,
          approvers: approversForLocation,
        })
      );
      // return {
      //   contactsForLocation,
      //   approversForLocation,
      //   address: {
      //     locationName: locationDetails?.locationName,
      //     zipcode: locationDetails?.zipcode,
      //     city: locationDetails?.city,
      //     stateName: locationDetails?.stateName,
      //     country: locationDetails?.country,
      //     latitude: locationDetails?.approxLatitude,
      //     longitude: locationDetails?.approxLongitude,
      //     streetAddress: locationDetails?.streetAddress,
      //   },
      // };
    } catch (error) {
      dispatch(setFailureLogs(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function getMultiShiftEncounterRate(url, params) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${url}/Employers/get-variable-payrate`,
        'POST',
        { ...params }
      );
      if (response && response?.getHourlyRates?.billingRateToDispaly ===
        "Variable") {
        dispatch(
          updateJobInfo({
            field: 'billingrate',
            data: response?.getHourlyRates?.billingRateToDispaly,
          })
        );
      }
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

// Get Incentive Markup
export function getIncentiveMarkup(url, params, jobType) {
  console.log(jobType);
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      if (jobType === 1 || jobType === 3) {
        const response = await requestUtil(
          `${url}/Employers/get-incentive-markup`,
          'POST',
          { ...params }
        );
        dispatch(setIncentiveMarkup(response))
        dispatch(setLoadingFlagDecrement());
      } else if (jobType === 2) {
        const response = await requestUtil(
          `${url}/Employers/get-encounter-incentive-markup`,
          'POST',
          { ...params }
        );
        dispatch(setIncentiveMarkup(response))
        dispatch(setLoadingFlagDecrement());
      }

    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  }
}

export const updateApprovarContactUser = ({ field, response, userList }) => {
  return async (dispatch) => {
    const updateUserList = [];
    response && response?.forEach(item => {
      if (userList?.indexOf(item?.id) > -1) {
        updateUserList?.push(item)
      }
    })
    dispatch(updateLocationList({ field, updateUserList }))
  };
};

export function getCheckMarkUpValue(url, params) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${url}/Employers/get-employer-markup`,
        'POST',
        { ...params }
      );
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}


export const masterDataBasedonJobLevel = ({url,params}) => {
  // console.log({url,params});
  return async(dispatch,getState) => {
    dispatch(setLoadingFlagIncrement());
    const state = getState();
    const { emrEhrSystemExperience, medicalSpeciality,certification } = state.jobOpportunity;
    try{
      const jobIdFlag = JSON.parse(sessionStorage.getItem("login"));
      if(!jobIdFlag?.accountFlags?.isShowQATab ){
        const emrEhrSystemExpMaster = await requestUtil(
          `${url}/Dropdown/Get-New-EMREHRSystems-byJobLevel`,
          'POST',{...params}
        );
        const certificationsMaster = await requestUtil(
          `${url}/Dropdown/Get-New-Certifications-byJobLevel`,
          'POST',{...params}
        );
        const specialitiesMaster = await requestUtil(
          `${url}/Dropdown/Get-New-Specialties-byJobLevel`,
          'POST',{...params}
        );
        dispatch(updateJobcertificationsMasterData(certificationsMaster));
        dispatch(updateJobspecialitiesMasterData(specialitiesMaster));
        dispatch(updateJobemrEhrSystemExpMasterData(emrEhrSystemExpMaster));
        if(medicalSpeciality?.speciality?.length > 0){
          const specialityList =  medicalSpeciality?.speciality?.map(item => item?.id); 
          const specialityFilterResult = specialitiesMaster?.filter(item => specialityList?.indexOf(item?.id) > -1)
          dispatch(updateMedicalSpecialityInfo({
            speciality: specialityFilterResult.length > 0 ? [...specialityFilterResult]:[],
            otherSpeciality: [
                {
                    name: '',
                    yearsOfExperience: 0
                }
            ]
        }));
        }
        if(certification?.definedCertification.length > 0){
          const certificationList =  certification?.definedCertification?.map(item => item?.id); 
          const certificationFilterResult = certificationsMaster?.filter(item => certificationList?.indexOf(item?.id) > -1)
          dispatch(updateCertificationInfo({
            definedCertification: certificationFilterResult.length > 0 ? [...certificationFilterResult]:[],
                otherCertification: [
                    {
                        name: '',
                        mandatory: false
                    }
                ]
      }))
        }
        if(emrEhrSystemExperience?.definedExperience?.length > 0){
          const emrEhrList =  emrEhrSystemExperience?.definedExperience?.map(item => item?.id); 
          const emrEhrFilterResult = emrEhrSystemExpMaster?.filter(item => emrEhrList?.indexOf(item?.id) > -1)
        dispatch(updateEMREHRSystemExpInfo({
          definedExperience: emrEhrFilterResult.length > 0 ? [...emrEhrFilterResult]:[],
          otherExperience: [
        {
          name: '',
          mandatory: false,
        },
      ],
    }))
        }
      }
   
    } catch(error){
      dispatch(setFailureLogs(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  }
}

export const loadJobToTemplate = ({baseURL,templateId}) => {
  return (dispatch,getState) => {
    const state = getState();
    const allTemplates =  state.jobOpportunity?.masterData?.allTemplates;
    const templateObj = allTemplates?.find(template => +template?.id === templateId);
    dispatch(updateStartJob(baseURL, 'templateID', templateObj));
  }
};
const getDateFormat = date => {
  const editedDate = new Date(date);
  const editedDateFormat = moment(editedDate).format("DD-MM-YYYY");
  return editedDateFormat
}
//call =>multishiftOccurrence, shiftStartDate, shiftEndDate, byWeeks, payRateOccurrenceAmount, jobMultishiftOccurrenceUpdateList
export const totalShiftAmountCalculation = () => {
  return (dispatch, getState) => {
    const dateAmountObj = {};
    const state = getState();
    const shiftStartDate = state?.jobOpportunity?.shift?.date;
    const shiftEndDate = state?.jobOpportunity?.shift?.endDate;
    const recursionFlag = state?.jobOpportunity?.recursionFlag;
    const byWeeks = state?.jobOpportunity?.byWeeks;
    const jobMultishiftOccurreneUpdateList = state?.jobOpportunity?.jobMultishiftOccurreneUpdateList;
    const payRateOccurrenceAmount = state?.jobOpportunity.payRateOccurrenceAmount;

    const startDateFormat = shiftStartDate && getDateJsFormat(shiftStartDate);
    const endDateFormat = shiftEndDate && getDateJsFormat(shiftEndDate);

    if((+recursionFlag === shiftTypeObj.multiShift) && startDateFormat && endDateFormat && byWeeks?.length > 0 && payRateOccurrenceAmount){
      while(startDateFormat.valueOf() <= endDateFormat?.valueOf()){
        const dayFormat = moment(startDateFormat).format("dddd")?.slice(0,2)?.toUpperCase();
        if(byWeeks?.indexOf(dayFormat) > -1){
          const dateFormat = moment(startDateFormat).format("DD-MM-YYYY");
          if(jobMultishiftOccurreneUpdateList?.length === 1){
            const occItem = jobMultishiftOccurreneUpdateList?.at(0);
            //editSeries modify
            dateAmountObj[dateFormat] = parseFloat(occItem?.payRateOccurrenceAmount);
          } else {
            //no modify => default
            dateAmountObj[dateFormat] = parseFloat(payRateOccurrenceAmount);
          }
        }
        startDateFormat.setDate(startDateFormat.getDate() + 1)
      };
      
      const defaultOccurrence = jobMultishiftOccurreneUpdateList?.at(0);
      const recurrenceException = defaultOccurrence?.RecurrenceException?.map(rcc => getDateFormat(rcc));
      const isOccurrenceEdited  = recurrenceException?.length > 0 ? true : false ;

      const editedOccurrencesDateList = (isOccurrenceEdited && jobMultishiftOccurreneUpdateList?.length > 1) ? jobMultishiftOccurreneUpdateList?.slice(1)?.map(occ => getDateFormat(occ?.Start)) : [];

      if(isOccurrenceEdited){
        recurrenceException?.map(rcc => {
          const position = editedOccurrencesDateList?.indexOf(rcc);
          //edit calculation
          if(position > -1 && dateAmountObj[rcc] ){
            const occItem = jobMultishiftOccurreneUpdateList?.at(position + 1)
            dateAmountObj[rcc] = parseFloat(occItem?.payRateOccurrenceAmount)
          } // delete calculation
          else if(dateAmountObj[rcc]){
            dateAmountObj[rcc] = 0;
          }
        })
        // editedOccurrences?.forEach(editedOcc  => {
        //   const editedDate = new Date(editedOcc?.Start);
        //   const editedDateFormat = moment(editedDate).format("DD-MM-YYYY");
        //   if(dateAmountObj[editedDateFormat]){
        //     dateAmountObj[editedDateFormat] = parseFloat(editedOcc?.payRateOccurrenceAmount)
        //   }
        // })
      }
      if(Object.values(dateAmountObj)?.length > 0){
        const payRateList = Object.values(dateAmountObj);
        let payRateTotalShiftAmount = 0;
        payRateList?.forEach(payRate => {
          payRateTotalShiftAmount+=payRate
        })
        dispatch(setPayRateType({name:"payRateTotalShiftAmount" ,value:payRateTotalShiftAmount ?? null}));
      }
    }
    console.log({dateAmountObj,jobMultishiftOccurreneUpdateList});
  }
}